import { Card, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
const { Title, Text } = Typography;

export const StatCard = ({
    title,
    count,
    nights,
    color,
    icon,
    loading
}: {
    title: string;
    count: number;
    nights: number;
    color: string;
    icon: React.ReactNode;
    loading?: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <Card
            hoverable
            bodyStyle={{ padding: '24px' }}
            style={{ borderRadius: '16px', background: '#fff' }}
            bordered={false}
            className="dashboard-stat-card"
            loading={loading}
        >
            <Space align="start" style={{ width: '100%' }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: `${color}15`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {icon}
                </div>
                <div style={{ flex: 1 }}>
                    <Title level={3} style={{ margin: '0 0 4px 0', color: color, fontSize: '24px', fontWeight: 600 }}>
                        {count.toLocaleString()}
                    </Title>
                    <Space direction="vertical" size={2}>
                        <Text style={{ fontSize: '14px', color: '#262626' }}>{title}</Text>
                        <Text style={{ fontSize: '13px', color: '#8c8c8c' }}>
                            {nights.toLocaleString()} {t('dashboard.nights')}
                        </Text>
                    </Space>
                </div>
            </Space>
        </Card>
    );
}